/** Text node state key holding the custom sx (JSON) assigned in the editor. Applied on the frontend only. */
export const CUSTOM_SX_STATE_KEY = 'sx';
